// extracted by mini-css-extract-plugin
export default {"td":"ClientesIndex_td__zDyen","inscricao":"ClientesIndex_inscricao__gQTua"};